// TODO update this to import from commmons
// import { gql } from '@reverbdotcom/commons/src/gql';
// eslint-disable-next-line no-restricted-imports
import { gql } from '@apollo/client';
import React from 'react';
import I18n from 'i18n-js';

import { Item2Prop65WarningData } from '@reverbdotcom/commons/src/gql/graphql';
import { useUser } from '@reverbdotcom/commons/src/user_hooks';
import SanitizedRender from '@reverbdotcom/commons/src/components/sanitized_render';

export const Item2Prop65WarningFragment = gql`
  fragment Item2Prop65WarningData on Listing {
    _id
    sellerId
    propSixtyFiveWarning
    propSixtyFiveWarningImg {
      href
    }
  }
`;

interface IProps {
  listing: Item2Prop65WarningData.Fragment;
}

export function Item2Prop65Warning({ listing }: IProps) {
  const user = useUser();
  if (!listing?.propSixtyFiveWarning) return null;

  const isCalifornian = user.stateCode === 'CA';
  const isSeller = !user.loggedOut &&
    listing.sellerId === user.id.toString();

  if (!(isCalifornian || isSeller)) return null;

  return (
    <div className="size-80 scaling-mt-6" data-prop-65>
      <p className="weight-bold mb-1">
        {I18n.t('discovery.item2Description.prop65.californiaResidents')}
      </p>
      <img
        src={listing.propSixtyFiveWarningImg.href}
        className="width-auto mr-space"
        style={{ height: '1rem' }}
        alt="Warning icon"
      />
      <SanitizedRender
        html={
          I18n.t(
            'discovery.item2Description.prop65.warning',
            {
              warningText: listing.propSixtyFiveWarning,
              tagOpen: '<b>',
              tagClose: '</b>',
              linkOpen: '<a href="https://www.P65Warnings.ca.gov">',
              linkClose: '</a>',
            },
          )
        }
        htmlTag="span"
      />
    </div>
  );
}
